// The sport rule behind a technique's warning icon: the move it falls under
// and its standing in each sport. Opened from the icon on a card, where a
// tooltip can't be hovered on a phone.
import { createPortal } from 'react-dom';
import { X, TriangleAlert } from 'lucide-react';
import { ARTS } from '../data/arts';
import { BANNED, type Rule } from '../utils/legality';

export default function RuleInfoModal({ rule, onClose }: { rule: Rule; onClose: () => void }) {
  return createPortal(
    <div className="frame-modal-backdrop" onClick={(e) => { e.stopPropagation(); onClose(); }}>
      <div className="gift-modal rule-info" onClick={(e) => e.stopPropagation()}>
        <button className="gift-modal-close" onClick={onClose} aria-label="Close"><X size={18} /></button>
        <div className="rule-info-head">
          <TriangleAlert size={18} />
          <span>{rule.name}</span>
        </div>
        <p className="rule-info-sub">Competition rules, by the major federations. Check your event's rulebook before you compete.</p>
        <div className="rule-info-rows">
          {ARTS.map((a) => {
            const v = rule.legality[a.id];
            const cls = v === BANNED ? ' rule-info-row--banned' : v ? ' rule-info-row--cond' : '';
            return (
              <div className={`rule-info-row${cls}`} key={a.id}>
                <span className="rule-info-art">{a.shortLabel}</span>
                <span className="rule-info-val">{v === BANNED ? 'Banned' : v ?? 'Legal'}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>,
    document.querySelector('.phone-frame') ?? document.body,
  );
}
